import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isTab } from '../domUtils';
import ShowIf from './ShowIfUtil';

/**
 * Wrapper component to show child component if it's a desktop/tablet display
 * @param {Children and If(boolean)} props
 */
export default class ShowIfTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      windowHeight: undefined,
      windowWidth: undefined
    };
  }

  componentDidMount() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () =>
    this.setState({
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth
    });

  render() {
    const { condition } = this.props;
    const { windowHeight, windowWidth } = this.state;
    const mergedCondition = condition && isTab();

    return (
      <ShowIf
        {...this.props}
        condition={mergedCondition}
        windowHeight={windowHeight}
        windowWidth={windowWidth}
      />
    );
  }
}

ShowIfTab.propTypes = {
  condition: PropTypes.bool
};

ShowIfTab.defaultProps = {
  condition: true
};
